import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
const DefaultFieldLayout = _ref => {
  let {
    target,
    fieldType,
    layout,
    lastRow,
    margin,
    ...rest
  } = _ref;
  const dataAttributes = {
    'data-hook': target ? "form-field-" + target : undefined,
    'data-field-type': fieldType
  };
  const rows = [1, 2, 3];
  const startRow = layout.row * rows.length;
  const gridRow = startRow + 1 + " / span " + rows.length;
  const gridColumn = layout.column + 1 + " / span " + layout.width;
  const marginBottom = (layout.row === lastRow ? 0 : margin.vertical) + "px";
  if ('children' in rest) {
    return /*#__PURE__*/React.createElement("div", _extends({
      style: {
        gridRow,
        gridColumn,
        marginBottom
      }
    }, dataAttributes), rest.children);
  }
  const {
    renderLabel,
    renderInput,
    renderDescription
  } = rest;
  const [labelRow, inputRow, descriptionRow] = rows.map(currentRow => startRow + currentRow);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      gridRow: labelRow,
      gridColumn
    }
  }, renderLabel()), /*#__PURE__*/React.createElement("div", _extends({
    style: {
      gridRow: inputRow,
      gridColumn
    }
  }, dataAttributes), renderInput()), /*#__PURE__*/React.createElement("div", {
    style: {
      gridRow: descriptionRow,
      gridColumn,
      marginBottom
    }
  }, renderDescription()));
};
export const createDefaultFieldLayout = _ref2 => {
  let {
    layout,
    margin,
    lastRow
  } = _ref2;
  const Component = props => {
    return /*#__PURE__*/React.createElement(DefaultFieldLayout, _extends({}, props, {
      layout: layout,
      margin: margin,
      lastRow: lastRow
    }));
  };
  return Component;
};
//# sourceMappingURL=default-field-layout.js.map